// Single tag normalization for storage, editing and summary keyword membership.
export const normalizeTag = (tag) => tag.toLowerCase().trim()
  .replace(/[#\s]+/g, '-').replace(/^-+|-+$/g, '');
